import {makeStyles} from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
    inputMargin: {
        marginBottom: "10px"
    }
}));